import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import RouterLink from 'src/components/ui/RouterLink';

const isExternalLink = (href) =>
	typeof href === 'string' && /^https?:\/\//.test(href);

const AuthNoAccess = ({
	label,
	desc,
	labelSite,
	linkSite,
	hint,
	labelReload,
	onReload,
}) => {
	const theme = useTheme();

	return (
		<Stack
			alignItems="start"
			spacing={4}
			sx={{
				p: 4,
				borderRadius: 4,
				background: theme.palette.secondary[100],
			}}
		>
			{label && (
				<Typography sx={{ fontSize: '64px', lineHeight: '64px' }}>
					{label}
				</Typography>
			)}

			{(desc || linkSite) && (
				<Stack spacing={1}>
					<Typography variant="h3">
						{desc && <>{desc}&nbsp;</>}
						{linkSite &&
							(isExternalLink(linkSite.href) ? (
								<Link
									href={linkSite.href}
									target={linkSite.target}
									rel="noopener noreferrer"
								>
									{labelSite}
								</Link>
							) : (
								<Link
									component={RouterLink}
									to={linkSite.href}
									{...linkSite}
								>
									{labelSite}
								</Link>
							))}
					</Typography>

					{hint && <Typography color="secondary">{hint}</Typography>}
				</Stack>
			)}

			{labelReload && onReload && (
				<Button variant="contained" onClick={onReload}>
					{labelReload}
				</Button>
			)}
		</Stack>
	);
};

AuthNoAccess.propTypes = {
	label: PropTypes.string,
	desc: PropTypes.string,
	labelSite: PropTypes.string,
	linkSite: PropTypes.shape(Link.propTypes),
	hint: PropTypes.string,
	labelReload: PropTypes.string,
	onReload: PropTypes.func,
};

export default AuthNoAccess;
